import { ShoppingCartSummaryDto } from "@/api/models/shoppingCart.model";
import {
	GenericSaleProcessBillingDto,
	GenericSaleProcessBusinessDto,
	GenericSaleProcessCoverageDto,
	GenericSaleProcessCustomerDto,
	GenericSaleProcessStatus
} from "@/api/sale-process/generic";
import getters from "./getters";
import mutations from "./mutations";
import { DeepPartial } from "@/utils/common.util";
import actions from "./actions";

export interface GenericSaleProcessState {
	id: number;
	status?: GenericSaleProcessStatus | "";
	coverage?: GenericSaleProcessCoverageDto;
	customer?: GenericSaleProcessCustomerDto;
	business?: GenericSaleProcessBusinessDto;
	billing?: GenericSaleProcessBillingDto;
	selectedBundle?: string;
	shoppingCartId?: string;

	notes?: string;
	digitelCircuitType?: string;
	// ui
	shoppingCartLoading: boolean;
	shoppingCartSummary?: ShoppingCartSummaryDto;
}

export const genericSaleProcessInitialState = (): DeepPartial<GenericSaleProcessState> => {
	return {
		status: "",
		coverage: {},
		customer: {
			identification: {}
		},
		business: {
			identification: {}
		}
	};
};

const state = genericSaleProcessInitialState();
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
